import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Portfolio from "./Portfolio";
import CaseStudy from './casestudy/Casestudy.js';
import ComingSoon from './ComingSoon';
import { Analytics } from "@vercel/analytics/react"

const App = () => {
  return (
    <Router>
      <Analytics />
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/case-study/:id" element={<CaseStudy />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
};

export default App;
